module.exports = __webpack_public_path__ + "img/camp.9a80065a.png";